import React from 'react';

import { useAppProvider } from '../../context/AppProvider';
import { useAppSelector } from '../../shared/hooks';
import {
  HomeRoutes,
  ROUTES,
} from '../../types/routes';
import Header from './Header';
import HomeHeader from './HomeHeader';

interface Props extends Omit<React.ComponentProps<typeof Header>, 'title'> {
  path: HomeRoutes;
  children?: React.ReactNode;
  title?: string;
  beforTitleAction?: React.ReactNode;
  customTitle?: React.ReactNode;
}

const DynamicHeader: React.FC<Props> = ({
  path,
  children,
  title,
  ...props
}) => {
  const { getRouteTitle } = useAppProvider();
  const {
    customRouter: { homeRoutes },
    hostMetadata: { isCommunityFeatureActive },
  } = useAppSelector((state) => state.app);

  const routes = isCommunityFeatureActive
    ? [
        ...homeRoutes,
        { name: ROUTES.COMMUNITY, config: { title: 'Community' } },
      ]
    : homeRoutes;

  const route = routes.find((r) => r.name === path);

  const routeTitle = getRouteTitle(path);

  // memoize the home component
  if (route) {
    return (
      <HomeHeader title={(title || routeTitle).toTitleCase()} {...props}>
        {children}
      </HomeHeader>
    );
  }

  return (
    <Header title={(title || routeTitle).toTitleCase()} {...props}>
      {children}
    </Header>
  );
};

export default React.memo(DynamicHeader);
